export const INSTRUCTOR_PATH = {
    LIST: '/instructors',
    CREATE: '/instructors/create',
    DETAIL: '/instructors/:id',
    EDIT_BASIC_INFO: '/instructors/:id/edit-basic-info',
    EDIT_INSTRUCTOR_DETAILS: '/instructors/:id/edit-details',
    EDIT_SKILLS_AND_COURSES: '/instructors/:id/edit-skills-and-courses',
} as const;
